export default __webpack_public_path__ + "static/media/593.718646e4.gif";